const heroTextData = {
  en: {
    'blogreach.title.1':'Testimonials',
    'blogreach.title.2': 'We are committed to offering services that optimize our clients\' processes. Their feedback proves it.'
  },
  es: {
    'blogreach.title.1':'Testimonios',
    'blogreach.title.2': 'Estamos comprometidos con ofrecer servicios que optimicen procesos de nuestros clientes. Sus opiniones lo comprueban. '
  }
};

export { heroTextData };
